export enum DropdownPosition {
  BOTTOM = 'bottom',
  TOP = 'top',
  AUTO = 'auto',
}
